import { render, staticRenderFns } from "./FreightBL.vue?vue&type=template&id=7a4e7832&scoped=true"
import script from "./FreightBL.vue?vue&type=script&lang=js"
export * from "./FreightBL.vue?vue&type=script&lang=js"
import style0 from "./FreightBL.vue?vue&type=style&index=0&id=7a4e7832&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e7832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4e7832')) {
      api.createRecord('7a4e7832', component.options)
    } else {
      api.reload('7a4e7832', component.options)
    }
    module.hot.accept("./FreightBL.vue?vue&type=template&id=7a4e7832&scoped=true", function () {
      api.rerender('7a4e7832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/FreightBL.vue"
export default component.exports